import { Injectable } from '@angular/core';
import { catchError, Observable, shareReplay, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiCacheService {

  private cache: Map<string, any> = new Map();

  constructor() {}

  cacheRequest<T>(key: string, requestFn: () => Observable<T>): Observable<T> {
    if (!this.cache.has(key)) {
      const shared$ = requestFn().pipe(
        shareReplay(1),
        catchError(err => {
          this.cache.delete(key);
          return throwError(() => err);
        })
      );
      this.cache.set(key, shared$);
    }

    return this.cache.get(key)!;
  }

  generateCacheKey(url: string, query?: any): string {
    if (!query) return url;

    const sortedKeys = Object.keys(query).sort();
    const queryStr = sortedKeys.map(k => `${k}=${query[k]}`).join('&');
    return `${url}?${queryStr}`;
  }

  clearCache(key: string) {
    this.cache.delete(key);
  }

  clearAllCache() {
    this.cache.clear();
  }

}
